/**
 * The busy indicator for the surfaces that render OUTSIDE the FireCMS provider
 * — sign-in and the state screens.
 *
 * Deliberately local rather than `@firecms/ui`'s `CircularProgress`: that
 * package does not tree-shake, so importing one spinner put 855 kB on the
 * critical path of every cold load, on a screen that renders nothing else from
 * the library. Inside the workspace, FireCMS primitives are still used as-is.
 *
 * Decorative by design: every caller wraps it in a live region that already
 * announces what is happening, so a second announcement would be noise.
 */
export function AdminSpinner({ size = 'small' }: { size?: 'small' | 'large' }) {
  return (
    <span
      className={`admin-spinner admin-spinner--${size}`}
      aria-hidden="true"
    />
  );
}
